import React from "react";
import { COMPANY_NAME } from "../../config";
import LoginWithGoogle from "./LoginWithGoogle";
import { Toaster } from "react-hot-toast";
import bgAbstract from "../../assets/loginPattern.svg";
import UsernamePassword from "../../components/auth/UsernamePassword";
import logo from "../../assets/images/idom-logo.webp";
function Login() {
  return (
    <>
      <div className=" h-screen bg-bodyBackground flex flex-col lg:flex-row overflow-hidden fixed w-full">
        <div
          className="w-full lg:block hidden lg:w-[60%] h-[60%] lg:h-full loginPage-bgImage relative l"
          style={{
            backgroundImage: `url(${bgAbstract})`,
          }}
        >
          <div className=" p-10 lg:p-16 h-full flex flex-col justify-between">
          <div className="w-[280px] flex flex-col overflow-hidden text-end">
              <h1 className=" text-white text-2xl lg:text-5xl font-bold drop-shadow-md tracking-wider font-roboto">
                iDoM
              </h1>
              <p className="text-white ">By iDigitize</p>
            </div>
            <div>
              <div className=" mt-10 lg:mt-0 mb-6 lg:mb-24">
                <h3 className=" drop-shadow-md text-white text-base lg:text-4xl mb-4 font-semibold">
                  Streamline HR Operations
                </h3>
                <p className=" text-white drop-shadow-md text-base lg:text-lg">
                  Unlock the Potential of Your Workforce. Discover a Dynamic Hub
                  Where Data Flourishes. Our HRMS Platform is the Gateway to a
                  More Efficient, Connected, and Innovative Workplace.
                </p>
              </div>
              <div className=" space-x-6">
                <a
                  href="http://"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" text-sm lg:text-base text-white drop-shadow-md hover:underline"
                >
                  Privacy Policy
                </a>
                <span className="text-white drop-shadow-md text-sm lg:text-base">
                  @ 2025, iDigitize I All Rights Reserved I Designed, Developed
                  & Managed By iDigitize Infotech LLP
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[40%] h-full lg:h-full flex flex-col items-center justify-center">
          <img
            src={logo}
            alt="iDom Logo"
            className="w-auto h-16 mb-5"
          />
          <h1 className=" text-primary font-semibold text-3xl mb-10">
            Welcome to iDoM
          </h1>
          <UsernamePassword />
          <div className="w-[69.5%] flex justify-end mt-10">
            <a
              className="underline underline-offset-2 font-medium"
              href="/forgot-password"
            >
              Forgot Password ?
            </a>
          </div>
          <div className="my-4 w-[69.5%] text-center relative">
            <div className="w-full bg-gray-300 h-px absolute top-1/2"></div>
            <span className="bg-white px-4 relative z-10 text-gray-500">
              OR
            </span>
          </div>
          <LoginWithGoogle />
        </div>
      </div>
    </>
  );
}

export default Login;
